import React from 'react';
import { 
  StyleSheet, 
  TouchableOpacity, 
  View, 
  Text
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../context/ThemeContext';

interface ThemeToggleProps {
  style?: object;
  showLabel?: boolean;
}

const ThemeToggle = ({ style, showLabel = true }: ThemeToggleProps) => {
  const { isDarkMode, toggleTheme, theme } = useTheme();
  
  return (
    <View style={[styles.container, style]}>
      {showLabel && (
        <Text style={[styles.label, { color: theme.colors.text }]}>
          {isDarkMode ? 'Modo Oscuro' : 'Modo Claro'}
        </Text>
      )}
      
      <TouchableOpacity
        style={[
          styles.toggle,
          isDarkMode ? styles.toggleDark : styles.toggleLight
        ]}
        onPress={toggleTheme}
        activeOpacity={0.7}
      >
        <View style={[
          styles.toggleButton,
          isDarkMode ? styles.toggleButtonRight : styles.toggleButtonLeft
        ]}>
          <Ionicons
            name={isDarkMode ? 'moon' : 'sunny'}
            size={16}
            color={isDarkMode ? '#FFF' : '#FFB800'}
          />
        </View>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  label: {
    fontSize: 16,
    marginRight: 8,
  },
  toggle: {
    width: 60,
    height: 30,
    borderRadius: 15,
    padding: 3,
  },
  toggleLight: {
    backgroundColor: '#E9F1FF',
  },
  toggleDark: {
    backgroundColor: '#2F3542',
  },
  toggleButton: {
    width: 24,
    height: 24,
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  toggleButtonLeft: {
    backgroundColor: '#FFD700',
    transform: [{ translateX: 0 }],
  },
  toggleButtonRight: {
    backgroundColor: '#384259',
    transform: [{ translateX: 30 }],
  },
});

export default ThemeToggle; 